<!--
 * @Descripttion: 边框设置
 * @Author: zenghua.wang
 * @Date: 2021-11-03 15:46:51
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2022-02-28 17:38:39
-->
<template>
  <el-collapse v-model="collapse" accordion>
    <el-collapse-item name="1" :title="component.basic">
      <config-base :data="data" />
    </el-collapse-item>

    <el-collapse-item title="边框设置">
      <el-form-item label="隐藏">
        <el-switch v-model="data.option.hide" :active-color="theme.active" :inactive-color="theme.inactive" />
      </el-form-item>

      <el-form-item label="背景色">
        <el-color-picker v-model="data.option.backgroundColor" :show-alpha="theme.showAlpha"
          :predefine="predefineColors" />
      </el-form-item>

      <el-form-item label="透明度">
        <el-slider v-model="data.option.opacity" :step="0.1" :max="1" />
      </el-form-item>

      <el-form-item label="类型">
        <el-radio-group v-model="data.option.borderType" size="small">
          <el-radio-button label="normal">常规</el-radio-button>
          <el-radio-button label="image">图片</el-radio-button>
        </el-radio-group>
      </el-form-item>

      <template v-if="data.option.borderType==='normal'">
        <el-form-item label="宽度(px)">
          <el-slider v-model="data.option.borderWidth" :max="50" />
        </el-form-item>

        <el-form-item label="圆角(px)">
          <el-slider v-model="data.option.borderRadius" :max="999" />
        </el-form-item>

        <el-form-item label="样式">
          <el-select v-model="data.option.borderStyle" clearable filterable placeholder="请选择">
            <el-option v-for="item in borderStyle" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="颜色">
          <el-color-picker v-model="data.option.borderColor" :show-alpha="theme.showAlpha"
            :predefine="predefineColors" />
        </el-form-item>
      </template>

      <template v-if="data.option.borderType==='image'">
        <el-form-item label="图片">
          <el-button type="primary" size="small" @click="showDialog">选 择</el-button>
        </el-form-item>

        <el-form-item label="" v-if="data.option.borderImage">
          <div class="border-image">
            <img :src="data.option.borderImage" />
          </div>
        </el-form-item>

        <el-form-item label="图片旋转角度">
          <el-input-number v-model="data.option.angle" :min="0" :max="360" />
        </el-form-item>

        <el-form-item label="上偏移">
          <el-slider v-model="data.option.sliceTop" :step="1" :max="50" />
        </el-form-item>

        <el-form-item label="下偏移">
          <el-slider v-model="data.option.sliceBottom" :step="1" :max="50" />
        </el-form-item>

        <el-form-item label="左偏移">
          <el-slider v-model="data.option.sliceLeft" :step="1" :max="50" />
        </el-form-item>

        <el-form-item label="右偏移">
          <el-slider v-model="data.option.sliceRight" :step="1" :max="50" />
        </el-form-item>
        <div class="xa-form-tips">
          备注：设置偏移量，可以遮盖背景色哦！
        </div>
      </template>
    </el-collapse-item>

    <!-- 边框 -->
    <el-dialog title="边框形状" :visible.sync="visible" append-to-body width="70%" class="border-dialog">
      <!-- <el-upload
        accept="image/*"
        :limit="1"
        :show-file-list="false"
      >
        <el-button
          size="small"
          type="primary"
        >点击上传</el-button>
      </el-upload> -->
      <div class="border-list">
        <img class="border-list-item" v-for="(item, index) in borderList" :src="item.url" :key="index"
          @click="setBorderImage(item.url)" />
      </div>
    </el-dialog>

    <!-- 权限设置 -->
    <config-auth :data="data" />
  </el-collapse>
</template>

<script>
import {
  predefineColors,
  component,
  theme
} from '@/dragComponents/model/default.js'
import apiUpload from '@/dragComponents/mixins/apiUpload'
import borderList from '@/dragComponents/public/images/border'

import configBase from '@/dragComponents/config/common/base.vue'
import configAuth from '@/dragComponents/config/common/auth.vue'

export default {
  name: 'config-border',
  mixins: [apiUpload],
  components: {
    configBase,
    configAuth
  },
  props: ['data', 'collapse'],
  data() {
    return {
      theme: theme,
      predefineColors: predefineColors,
      component: component,
      visible: false,
      borderList: borderList,
      borderStyle: [
        {
          value: 'solid',
          label: '实线'
        },
        {
          value: 'dashed',
          label: '虚线'
        },
        {
          value: 'double',
          label: '双线'
        },
        {
          value: 'dotted',
          label: '点状'
        },
        {
          value: 'groove',
          label: '凹槽'
        },
        {
          value: 'ridge',
          label: '垄状'
        }
      ]
    }
  },
  methods: {
    showDialog() {
      this.visible = true
    },
    setBorderImage(url) {
      this.data.option.borderImage = url
      this.visible = false
    }
    // onHttpRequest(file) {
    //   this.apiUploadPicture(file, (path) => {
    //     this.data.option.borderImage = path
    //   })
    // }
  }
}
</script>
<style lang="scss" scoped>
@import "@/dragComponents/styles/variables.scss";

.border {
  &-dialog {
    :deep(.el-dialog__header) {
      background: #333;
    }
    :deep(.el-dialog__title) {
      color: #fff;
    }
    :deep(.el-dialog__body) {
      padding: 10px;
      background: #333;
    }
    :deep(.el-dialog__headerbtn .el-dialog__close) {
      color: #fff;
    }
  }

  &-list {
    height: 460px;
    @include scrollable();

    &-item {
      width: 100px;
      height: 100px;
      margin: 20px 10px;
      cursor: pointer;
    }
  }

  &-image {
    width: 100px;
    height: 100px;
    padding: 2px;
    background: #333;

    img {
      width: 100px;
      height: 100px;
    }
  }
}
</style>
